import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

const styles = (theme) => ({
  label: {
    userSelect: 'none',
    marginRight: 0,
  },

  labelChecked: {
    '& span': {
      color: theme.palette.secondary['dark'],
    },
  },

  reversed: {
    flexDirection: 'row-reverse',
  },
});

class SwitchWithLabel extends React.Component {
  render() {
    const { classes, label, checked, reversed, ...props } = this.props;

    const labelClassName = classnames(classes.label, {
      [classes.labelChecked]: checked,
      [classes.reversed]: reversed,
    });

    return (
      <FormControlLabel
        className={labelClassName}
        label={label}
        control={<Switch checked={checked} {...props} />}
      />
    );
  }
}

SwitchWithLabel.defaultProps = {
  checked: false,
  reversed: false,
};

SwitchWithLabel.propTypes = {
  checked: PropTypes.bool,
  classes: PropTypes.shape({
    label: PropTypes.string.isRequired,
    labelChecked: PropTypes.string.isRequired,
    reversed: PropTypes.string.isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
  reversed: PropTypes.bool,
};

export default withStyles(styles)(SwitchWithLabel);
